module.exports = __webpack_public_path__ + "static/media/manzo_03_thumb.ab99ca9c.png";